export default {
  payrollDetailList: [],
  payrollDetailInfo: {}
}
